export const JOBS_ANALYTICS_EVENTS = {
  jobPostCreated: "jobs job post created",
  jobPostUpdated: "jobs job post updated",
  jobPostPublished: "jobs job post published",
  jobPostUnpublished: "jobs job post unpublished",
  jobPostHidden: "jobs job post hidden",
  jobPostRevertedToDraft: "jobs job post reverted to draft",
  jobPostClosed: "jobs job post closed",
  jobPostDeleted: "jobs job post deleted",
  jobPostRenewed: "jobs job post renewed",
  jobPostSentForReview: "jobs job post sent for review",
  applicantReviewSlackRequested: "jobs applicant review slack requested"
} as const;

export type JobsAnalyticsSource =
  | "jobs_create"
  | "jobs_edit"
  | "jobs_publish"
  | "jobs_unpublish"
  | "jobs_hide"
  | "jobs_revert_draft"
  | "jobs_close"
  | "jobs_delete"
  | "jobs_renew"
  | "jobs_send_review"
  | "jobs_slack_review_request";

export type JobsAnalyticsData = {
  source: JobsAnalyticsSource;
  success: boolean;
  jobPostId?: string;
  action?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
  isAdminPublish?: boolean;
  status?: string;
  reviewerCount?: number;
};

export function getJobsAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: JobsAnalyticsSource;
  success?: boolean;
} & Omit<JobsAnalyticsData, "source" | "success">): JobsAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
